import React, { useState, useEffect } from "react";

import MasterPriceTable from "./MasterPriceTable";
import MasterPriceAdd from "./MasterPriceAdd";
import MasterPriceEdit from "./MasterPriceEdit";
import MasterPriceImport from "./MasterPriceImport";
import MasterPriceHeader from "./MasterPriceHeader";

import useApiNew from "../../../utils/useApiNew";
import axios from "axios";

import Breadcrumbs from "../../../components/ui/Breadcrumbs";

import DeleteAlert from "../../../components/ui/DeleteAlert";

import Notification, {
  errorNotify,
  successNotify,
} from "../../../Services/Notification";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const priceApiURL = `${process.env.REACT_APP_API_URL}api/price`;
const exportScriptApiURL = `${process.env.REACT_APP_API_URL}api/export-price`;
const importScriptApiURL = `${process.env.REACT_APP_API_URL}api/import-script`;

const MasterPrice = () => {
  const [renderKey, setRenderKey] = useState(0);
  const [isAdd, setIsAdd] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [isImport, setIsImport] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState("");
  const [globalFilters, setGlobalFilters] = React.useState();
  const [bankData, setBankData] = React.useState();
  const [statusFilter, setStatusFilter] = React.useState();
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };
  const name = "price";

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  let { data, loading } = useApiNew(
    `${priceApiURL}${filter ? "/" + filter : ""}`,
    "GET",
    { headers },
    renderKey,
  );
  data = data?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
  }));

  useEffect(() => {
    if (data) {
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  }, [data]);

  const filterBankData = () => {
    let filterData = data;
    if (statusFilter) {
      filterData = data.filter((item) => statusFilter === item.status);
    }
    if (globalFilters) {
      filterData = data.filter(
        (item) =>
          item?.item_description
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.short_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.unit_price
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.item_type
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.status?.toLowerCase() === globalFilters?.toLowerCase(),
      );
    }
    setBankData(filterData);
  };
  useEffect(() => {
    filterBankData();
  }, [globalFilters, statusFilter]);

  const filterStatus = () => {
    let setStatus = data;

    if (statusFilter) {
      setStatus = setStatus.filter((item) => item.status === statusFilter);
    }

    return setStatus;
  };

  const handleFilterChange = (filters) => {
    setStatusFilter(filters);
  };

  useEffect(() => {
    filterStatus();
  }, [statusFilter]);

  //EDIT

  const handleGetOnePrice = (id) => {
    const foundItem = data.find((d) => d.id === id);
    console.log(foundItem);

    return foundItem;
  };

  // ADD

  const handleAddPrice = async (data) => {
    setIsButtonClicked(true);
    triggerRerender();
    try {
      const res = await axios.post(priceApiURL, data, { headers });
      const resData = res.data;

      if (!resData.error || resData) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        triggerRerender();
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT

  const handleEditPrice = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${priceApiURL}/${segmentId}`;

    try {
      const res = await axios.put(updateAPI, data, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeletePrice = async () => {
    const deleteAPI = `${priceApiURL}/${selectedItemId}`;
    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  // IMPORT
  const handleImportPrice = async (formData) => {
    const res = await axios.post(importScriptApiURL, formData);
    console.log(res);

    return res.data;
  };

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportScriptApiURL;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      setIsDownloadClicked(false);
      errorNotify("Something went wrong.");
    }
  };

  // DOWNLOAD
  const handleDownloadPrice = async (id) => {
    setIsDownloadClicked(true);
    const filename = `Price-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };

  const breadcrumbs = ["Home", "Master", "Pricing"];

  const buttonConfig = {
    value: "script",
    name: "Scrip",
    getOneHandler: handleGetOnePrice,
    addHandler: handleAddPrice,
    editHandler: handleEditPrice,
    deleteHandler: handleDeletePrice,
    downloadHandler: handleDownloadPrice,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterPriceHeader
        setFilter={setFilter}
        filterStatus={filterStatus}
        onFilterChange={handleFilterChange}
        setBankData={setBankData}
        setStatusFilter={setStatusFilter}
      />
      <MasterPriceTable
        tableData={globalFilters || bankData ? bankData : data}
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setIsImport={setIsImport}
        setSelectedItemId={setSelectedItemId}
        renderKey={renderKey}
        isLoading={isLoading}
        setGlobalFilters={setGlobalFilters}
        loading={loading}
        actionPermissions={actionPermissions("masters", "Pricing")}
        isDownloadClicked={isDownloadClicked}
      />
      {isAdd && <MasterPriceAdd buttonConfig={buttonConfig} isButtonClicked={isButtonClicked} />}
      {isEdit && (
        <MasterPriceEdit
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isImport && (
        <MasterPriceImport
          setIsImport={setIsImport}
          handleImportScript={handleImportPrice}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterPrice;
